import React, { Component } from 'react';
import without from 'lodash/without';
import Select from 'react-select-box';
import { Toggle } from '../../../common/Toggle';

class ProjectionsAlert extends Component {
  constructor(props) {
    super(props);

    this.dropDownList = this.dropDownList.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getPoundSymbol = this.getPoundSymbol.bind(this);
    this.shakeFields = this.shakeFields.bind(this);
    this.shakeZeroFields = this.shakeZeroFields.bind(this);

    this.state = {
      selectedValue: '1',
      overDraftAmount: 0,
      shakeSet: [],
    };
  }

  dropDownList() {
    return (
      <section className="alerts-drop-down">
        <Select
          name="select"
          onChange={this.onChange}
          value={this.props.selectedValue}
        >
          <option value="1">
            {this.props.content.projectionAlertsDropdownOption1}
          </option>
          <option value="2">
            {this.props.content.projectionAlertsDropdownOption2}
          </option>
        </Select>
      </section>
    );
  }

  onChange(e) {
    // if (e === "2" && this.state.overDraftAmount < this.props.alertsAmountValue) {
    // 	this.setState({ selectedValue: "2" });
    // } else {
    // 	this.setState({ selectedValue: "1" });
    // }
    this.props.selectDropdown(e);
  }

  getPoundSymbol() {
    if (this.props.dropdownSelection === 1) {
      return <span>&pound;</span>;
    } else if (this.props.dropdownSelection === 2) {
      return <span>-&pound;</span>;
    } else return null;
  }

  shakeFields(name) {
    this.refs[name].classList.add('shake');
    this.state.shakeSet.push(name);

    setTimeout(() => {
      this.state.shakeSet.map((item) => {
        if (this.refs[item] !== undefined) {
          this.refs['exceedFade'].classList.add('p-fade');
          this.refs[item].classList.remove('shake');
        }
        let result = without(this.state.shakeSet, item);
        this.setState({ shakeSet: result });
        this.props.shakeFalse();
      });
    }, 2000);
  }

  shakeZeroFields(name) {
    this.refs[name].classList.add('shake');
    this.state.shakeSet.push(name);
    setTimeout(() => {
      this.state.shakeSet.map((item) => {
        if (this.refs[item] !== undefined) {
          this.refs[item].classList.remove('shake');
        }
        let result = without(this.state.shakeSet, item);
        this.setState({ shakeSet: result });
      });
    }, 2000);
  }

  render() {
    if (this.props.shakeamount) {
      if (this.refs['exceedFade']) {
        this.refs['exceedFade'].classList.remove('p-fade');
      }
      this.shakeFields('overdraftAmount');
    }
    if (this.props.shakeamountZero) {
      this.shakeZeroFields('overdraftAmount');
    }
    return (
      <div className="projection-alerts">
        <p className="when-i-have-a-balance-of">
          {this.props.content.projectionSettingsAlertsAndNotificationsContent}
        </p>
        {this.props.shakeamount ? (
          <p ref="exceedFade" className="exceed-amount">
            Overdraft exceeded
          </p>
        ) : (
          <p ref="exceedFade" />
        )}
        <article className="adjust-amount">
          <section className="alerts-text-box">
            <div className="currency">
              {this.getPoundSymbol()}
              <input
                type="text"
                placeholder=""
                value={this.props.alertsAmountValue}
                onChange={this.props.changeTheValue}
                ref="overdraftAmount"
                className="face animated"
              />
            </div>
          </section>
          {this.dropDownList()}
        </article>
        <p className="send-me-an-in-app-notification">
          {this.props.content.projectionSettingsAlertsAndNotificationsFooter}
        </p>
        <article className="sms-notification">
          <section>
            <div className="toggle default">
              <Toggle
                aria-label="No label tag"
                defaultChecked={this.props.notificationFlag}
                value={this.props.notificationFlag}
                onChange={this.props.changeTheNotificationFlag}
              />
            </div>
          </section>
          <section>
            <p className="send-me-an-sms">
              {this.props.content.projectionAlertAndNotificationsToggleText}
            </p>
          </section>
        </article>
      </div>
    );
  }
}

export { ProjectionsAlert };
